angular.module('gantt.dependencies.templates', []).run(['$templateCache', function ($templateCache) {

}]);
